import { neutrals } from 'src/theme/colors';
import { StyleSheet } from 'react-native';

export const style = StyleSheet.create({
  background: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 50,
  },
  layer: {
    backgroundColor: `${neutrals.black}66`,
    width: '100%',
    height: '100%',
  },
  content: {
    position: 'absolute',
    zIndex: 51,
    backgroundColor: neutrals.white,
    height: '100%',
    shadowColor: neutrals.black,
    shadowOpacity: 0.25,
    shadowRadius: 62,
    shadowOffset: { width: 0, height: 4 },
  },
});
